var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #171954;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m12.58,60.33l6.06-13.01.27-.24L54.49,14.67l8.01,8.8L26.61,56.15l-14.03,4.18Zm9.02-10.84l-2.38,5.11,5.58-1.66,32.62-29.7-3.17-3.48-32.66,29.73Zm4.11,5.05h0,0Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EDITAR.2af418655cfc68642fb5fe9e45cc4afd.svg";